// src/components/SocialSidebar.jsx
import React from "react";
import { EmailIcon, FaceBookIcon, InstagramIcon, LinkedInIcon, PhoneIcon, TwitterIcon, Youtube } from "../Icons";

const SocialSidebar = () => {

  const handlePhoneCall = () => {
    const phoneNumber = "7900368003";
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    }
  };

  const handleEmailClick = () => {
    const email = "info@vaikuntamaharuchulu.com";
    if (email) {
      window.location.href = `mailto:${email}`;
    }
  };

  return (
    <div className="hidden md:flex fixed hidden top-1/3 left-0 z-10 flex flex-col items-center gap-4 bg-gray-800 text-white py-3 px-2 rounded-r-lg shadow-lg">

      <button
        onClick={handlePhoneCall}
        className="transition-transform duration-300 hover:scale-110 hover:text-blue-500"
        aria-label="Call us"
      >
        <PhoneIcon />
      </button>

      <button
        onClick={handleEmailClick}
        className="transition-transform duration-300 hover:scale-110 hover:text-red-500"
        aria-label="Email us"
      >
        <EmailIcon />
      </button>

      <a
        href="https://www.facebook.com/profile.php?id=61574574467586"
        target="_blank"
        rel="noopener noreferrer"
        className="transition-transform duration-300 hover:scale-110 hover:text-blue-500"
        aria-label="Facebook"
      >
        <FaceBookIcon />
      </a>

      <a
        href="https://www.instagram.com/imash.insurance/"
        target="_blank"
        rel="noopener noreferrer"
        className="transition-transform duration-300 hover:scale-110 hover:text-pink-500"
        aria-label="Instagram"
      >
        <InstagramIcon />
      </a>

      <a
        href="https://www.linkedin.com/company/imash-technologies/posts/?feedView=all"
        target="_blank"
        rel="noopener noreferrer"
        className="transition-transform duration-300 hover:scale-110 hover:text-blue-700"
        aria-label="LinkedIn"
      >
        <LinkedInIcon />
      </a>

      <a
        href="https://x.com/imashInsurance"
        target="_blank"
        rel="noopener noreferrer"
        className="transition-transform duration-300 hover:scale-110 hover:text-sky-400"
        aria-label="Twitter"
      >
        <TwitterIcon />
      </a>

      <a
        href="https://www.youtube.com/@Imash_insure"
        target="_blank"
        rel="noopener noreferrer"
        className="transition-transform duration-300 hover:scale-110 hover:text-red-500"
        aria-label="YouTube"
      >
        <Youtube />
      </a>

    </div>
  );
};

export default SocialSidebar;
